module.exports = __webpack_public_path__ + "img/Weapon_249.5009d043.png";